import { render, staticRenderFns } from "./floor-detail.vue?vue&type=template&id=585d2e70&"
import script from "./floor-detail.vue?vue&type=script&lang=js&"
export * from "./floor-detail.vue?vue&type=script&lang=js&"
import style0 from "./floor-detail.vue?vue&type=style&index=0&id=585d2e70&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports